import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { Slot } from '@radix-ui/react-slot'
import gsap from 'gsap'

import { cn } from '@/lib/utils'

export type HeroParallaxProps = HTMLAttributes<HTMLDivElement>

const HeroParallax = ({ className, children, ...props }: HeroParallaxProps) => {
  const media = useRef<HTMLElement>(null)
  const root = useRef<HTMLDivElement>(null)

  useGSAP(
    () => {
      if (media.current instanceof HTMLVideoElement) return

      gsap.to(media.current, {
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          markers: false,
          scrub: true,
          once: false
        },
        yPercent: 20,
        ease: 'none'
      })

      return () => {
        gsap.killTweensOf(media.current)
      }
    },
    { scope: root }
  )

  return (
    <div ref={root} className={cn(className)} {...props}>
      <Slot ref={media} className="!h-[115%]">
        {children}
      </Slot>
    </div>
  )
}

export default HeroParallax
